
import React, { Component } from 'react'
import { tableHelper, momentHelper } from './helpers'
import { Pagination, PageHeader, Tabs, Tab } from 'react-bootstrap'
import { Box } from 'reactjs-admin-lte'
// import { connect } from 'react-redux';

const mockJson = {
  clientList: [
    {
      clientId: '1xx',
      clientName: 'กรุงเทพประกันภัย'
    },
    {
      clientId: '2xx',
      clientName: 'ไทยพาณิชย์'
    }
  ],

  workList: [
    {
      registrationNo: 'กข 1234',
      chassisNo: '',
      claimNo: '2015-15331-001491',
      ownerName: 'บ.ไทยน้ำทิพย์',
      parkDate: '07/05/2017',
      deliverDate: '17/05/2017',
      quotationDate: '09/05/2017',
      quotationPrice: '117967.50',
      offerPrice: '117967.50',
      confirmPrice: '81800.00 ',
      totalAmount: '81800.00',
      totalCost: '0',
      balance: '81800',
      statusText: 'รอเอกสารจากคุณนพดลเจ้าหน้าที่คุมราคา',
    }
  ],
  clientName: 'กรุงเทพประกันภัย',
  updatedDate: '08/08/2017',
  listCount: 100
}

class ReportPendingWork extends Component {

  constructor(...args) {
    super(...args)
    this.state = {
      data: mockJson,
      activePage: 1
    }
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
  }

  onTabSelect(key) {
    // load new workList here
    const newData = { ...this.state.data }
    newData.clientName = key

    this.setState({
      data: newData
    })
  }

  renderBody() {
    const excludedColumns = ['deliverDate', 'quotationDate']
    return tableHelper.renderRows(this.state.data.workList, excludedColumns)
  }

  renderHeader() {
    const display = "สรุปรายงานรถ บ."
      + this.state.data.clientName
      + " ณ วันที่ "
      + momentHelper.getFullDate(this.state.data.updatedDate)
    return <div className="text-center"><PageHeader>{display}</PageHeader></div>
  }

  renderPaging() {
    const items = this.state.data
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  renderTable() {
    return (
      <div>
        {this.renderHeader()}
        <table id='pendingWork' className='table table-responsive table-hover table-bordered-solid'>
          <thead>
            <tr>
              <th className='text-center' rowSpan={2}>ทะเบียน</th>
              <th className='text-center' rowSpan={2}>เลข C</th>
              <th className='text-center' rowSpan={2}>เลขเคลม</th>
              <th className='text-center' rowSpan={2}>เจ้าของรถ</th>
              <th className='text-center' rowSpan={2}>ว/ด/ป ส่งคุมราคา</th>
              <th className='text-center' colSpan={2}>ราคาประเมิน</th>
              <th className='text-center'>ราคายืนยัน</th>
              <th className='text-center' rowSpan={2}>รวมทั้งสิ้น</th>
              <th className='text-center' rowSpan={2}>คชจ</th>
              <th className='text-center' rowSpan={2}>คงเหลือ</th>
              <th className='text-center' rowSpan={2}>สถานะ</th>
            </tr>
            <tr>
              <th className='text-center'>1</th>
              <th className='text-center'>รวมราคาเสนอ</th>
              <th className='text-center'>1</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
        </table>
        {this.renderPaging()}
      </div>
    )
  }

  renderTabs() {
    //let title = (<div><FontAwesome name='search'/>ค้นหา</div>)
    return this.state.data.clientList.map((client, index) => (
      <Tab key={index} eventKey={client.clientName} title={client.clientName}>{this.renderTable()}</Tab>
    ))
  }

  render() {
    return (
      <Box>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          <Tabs activeKey={this.state.data.clientName} onSelect={this.onTabSelect.bind(this)} id="controlled-tab">
            {this.renderTabs()}
          </Tabs>
        </Box.Body>
      </Box>
    )
  }
}

export default ReportPendingWork;





// WEBPACK FOOTER //
// ./src/view/report/ReportPendingWork.js